import axios from "axios";
import { logout } from "module/main/store/auth/utils";
var baseURL = process.env.REACT_APP_LOCAL_BACKEND_URL || window.location.origin;
var axiosPublicInstance = axios.create({ baseURL: baseURL });
// Doing this to avoid circular dependency with the store
export var injectInterceptor = function (store) {
    axiosPublicInstance.interceptors.response.use(function (goodResponse) { return goodResponse; }, function (badResponse) {
        var _a;
        // Log the user out if the response is a 401 (JWT expired/invalid, etc)
        if (((_a = badResponse.response) === null || _a === void 0 ? void 0 : _a.status) === 401)
            store.dispatch(logout());
        return Promise.reject(badResponse);
    });
};
export default axiosPublicInstance;
